// extracted by mini-css-extract-plugin
module.exports = {"userAuthInfo":"UserProfileTable_userAuthInfo__3KlpL","auth_table":"UserProfileTable_auth_table__1ORmf"};